module.exports = __webpack_public_path__ + "img/snb_bsgs.548254eb.svg";